import { useTagsStore } from '@/feature/tags/store'

import { TagsPopoutView } from '../TagsPopoutView/TagsPopoutView.component'

export const TagsFilterPopout = () => {
  const {
    isFilterPopoutOpen,
    filterPopoverPosition,
    closeFilterPopout,
    globalOrgTags,
    filteringTags,
    setFilteringTags,
  } = useTagsStore()

  return (
    <TagsPopoutView
      popoverPosition={filterPopoverPosition}
      closeTagsPopout={closeFilterPopout}
      isTagsPopoutOpen={isFilterPopoutOpen}
      tagsForSelection={globalOrgTags}
      storedTags={filteringTags}
      setStoredTags={setFilteringTags}
    />
  )
}
